import React from 'react';
import { 
	func, 
	array ,
	object
} from 'prop-types';
import style,{mobileStyle} from './style';

const MobilePresenter = ({
	recipes,
	profile,
	onClickRecipe,
	...props
}) =>{
	return (
		<mobileStyle.Wrapper>
			<mobileStyle.UsersWrapper>
				<div>
					<mobileStyle.UserName>
						{profile&&profile.userName}
					</mobileStyle.UserName>
					{profile.twitterId && (
						<mobileStyle.SnsWrapper>
							<a href={`https://twitter.com/${profile.twitterId}`}>
								<style.TwitterIcon />
							</a>
						</mobileStyle.SnsWrapper>
					)}
				</div>
				<div>
					<mobileStyle.UserIcon src={(profile&&profile.imageUrl) || 'https://via.placeholder.com/400x400/ffffff/616161.png?text=No+Image'} />
				</div>
				<mobileStyle.Comment>{profile&&profile.comment}</mobileStyle.Comment>
			</mobileStyle.UsersWrapper>
			<style.Divider/>
			<mobileStyle.Recipes>
				<label>Recipes</label>
				{recipes.map(recipe=>{
					const thumbFromCount = (recipe.thumbFrom && recipe.thumbFrom.length) || 0;
					const likeFromCount = (recipe.likeFrom && recipe.likeFrom.length) || 0;
					return (
						<mobileStyle.Recipe key={recipe.id} onClick={onClickRecipe(recipe)}>
							<div>{recipe.name}</div>
							<mobileStyle.RecipeStatus>
								{likeFromCount > 0 && (
									<React.Fragment>
										<style.StarIcon />{likeFromCount}
									</React.Fragment>
								)}
								{thumbFromCount > 0 && (
									<React.Fragment>
										<style.ThumbsUpIcon />{thumbFromCount}
									</React.Fragment>
								)}
							</mobileStyle.RecipeStatus>
							
						</mobileStyle.Recipe>
					);
				})}
			</mobileStyle.Recipes>
			
			
		</mobileStyle.Wrapper>
	);
};
    


MobilePresenter.propTypes = {
	recipes : array.isRequired,
	profile : object,
	onClickRecipe : func
};

export default MobilePresenter;